import { createContext } from 'react';

import { SummaryContextReturnType } from '@p/audience/shared/summary/types/context-return.type';

export const SummaryContext = createContext<SummaryContextReturnType | null>(null);
